const dispatchTemplate = {
  inform: 0,
  success: 0,
  fail: 0,
}

export default function () {
  return {
    url: null,
    model: null,
    tree: null,
    branch: null,
    watch: {
      create: true,
      read: true,
      update: true,
      delete: true,
    },

    initialized: false,

    permit: {
      create: false,
      read: false,
      update: false,
      delete: false,
    },

    dispatch: {
      create: { ...dispatchTemplate },
      read: { ...dispatchTemplate },
      update: { ...dispatchTemplate },
      delete: { ...dispatchTemplate },
    },

    inProgress: 0,
  }
}
